import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _AcademicEducation, _PersonalReferences } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { SelectTHConstantsValue } from "../../../../bpm/config/Componentes/SelectTHConstantsValue";
import usePaginator from "../../../../theme/Component/usePaginator";



interface Props {
    Account: number;
}

export const PersonalReferences = ({ Account }: Props) => {

    const PersonalReferences = useDataBean(_PersonalReferences);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();
    useEffect(() => {
        getListavdos();
    }, [Account])

    const getLista = () => {

        PersonalReferences.instance.getPersonalReferencesCatalogPorPropiedades({ State: 1, IDAccount: Account }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )

    }

    const getListavdos = () => {

        PersonalReferences.instance.getPersonalReferencesAccountReport(paginador.page, 15, { State: 1, IDAccount: Account }).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        PersonalReferences.setBean({
            IDAccount: Account,
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        PersonalReferences.update().then(
            (resp: any) => {
                getListavdos();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        PersonalReferences.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }
    const head = [
        { title: 'ID', property: 'IDPersonalReferences', visible: true },
        { title: 'Nombre completo', property: 'FullName', visible: true },
        { title: 'Telefono Contacto', property: 'PhoneNumber', visible: true },
        { title: 'Relacion', property: 'IDRelationshipName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={PersonalReferences.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Nombre completo</label>
                            <input type='text' name="FullName" className="form-control" value={PersonalReferences.bean.FullName} onChange={PersonalReferences.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Telefono Contacto</label>
                            <input type='text' name="PhoneNumber" className="form-control" value={PersonalReferences.bean.PhoneNumber} onChange={PersonalReferences.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Relacion</label>
                            <SelectTHConstantsValue code={807} value={PersonalReferences.bean.IDRelationship} onChange={(e: any) => { PersonalReferences.setBean({ ...PersonalReferences.bean, "IDRelationship": e }) }}></SelectTHConstantsValue>
                        </div>

                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}